import { AboutUsPage } from 'src/pages'

const AboutUs = () => {
  return <AboutUsPage />
}
export default AboutUs
